import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
const stats = [{
  value: '150+',
  label: 'Projects Completed'
}, {
  value: '8+',
  label: 'Years Experience'
}, {
  value: '50+',
  label: 'Happy Clients'
}, {
  value: '2',
  label: 'Global Locations'
}];
export function About() {
  return <Section id="about" className="bg-[#091220] relative overflow-hidden" data-id="element-12">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-[#d8a43e]/5 to-transparent pointer-events-none" data-id="element-13" />

      <div className="grid lg:grid-cols-2 gap-16 items-center relative z-10" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} data-id="element-15">
          <span className="text-[#d8a43e] font-mono text-sm tracking-widest uppercase" data-id="element-16">
            // About KM Consulting
          </span>
          <h2 className="mt-3 text-4xl font-bold text-white mb-6" data-id="element-17">
            Your Partner in <br data-id="element-18" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-500" data-id="element-19">
              Digital Transformation
            </span>
          </h2>
          <div className="space-y-4 text-gray-400 text-lg leading-relaxed border-l border-white/10 pl-6" data-id="element-20">
            <p data-id="element-21">
              At KM Consulting, we believe in the power of technology to
              transform businesses. Founded with a vision to bridge the gap
              between complex technology and business needs, we have grown into
              a premier digital agency serving clients across Nigeria and the
              UK.
            </p>
            <p data-id="element-22">
              Our team of expert developers, designers, and strategists work
              collaboratively to deliver bespoke solutions that not only look
              great but drive tangible business growth.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 mt-12" data-id="element-23">
            {stats.map((stat, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white/5 p-6 rounded-lg border border-white/5 hover:border-[#d8a43e]/30 transition-colors" data-id="element-24">
                <div className="text-4xl font-bold text-[#d8a43e] mb-1 font-mono" data-id="element-25">
                  {stat.value}
                </div>
                <div className="text-gray-400 font-medium text-sm uppercase tracking-wide" data-id="element-26">
                  {stat.label}
                </div>
              </motion.div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative" data-id="element-27">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-white/10 group" data-id="element-28">
            <img src="https://cdn.magicpatterns.com/uploads/euwLoeGAyBsEHTDLRpXiR5/KM-Consulting-Portfolio-5.jpg" alt="OPPEIN Abuja - Responsive Website Design" className="w-full h-auto object-cover group-hover:scale-105 transition-all duration-700" data-id="element-29" />
          </div>

          {/* Decorative elements */}
          <div className="absolute -bottom-6 -right-6 w-32 h-32 border-r-2 border-b-2 border-[#d8a43e] rounded-br-3xl -z-10 opacity-50" data-id="element-30" />
          <div className="absolute -top-6 -left-6 w-32 h-32 border-l-2 border-t-2 border-[#d8a43e] rounded-tl-3xl -z-10 opacity-50" data-id="element-31" />
        </motion.div>
      </div>
    </Section>;
}